import * as types from '../mutation-types'

// state
export const state = {
  moduleIndicator: null,
}

// mutations
export const mutations = {
  [types.SET_MODULE_INDICATOR_START] (state) {
    state.moduleIndicator = null
  },

  [types.SET_MODULE_INDICATOR_SUCCESS] (state, moduleIndicator) {
    state.moduleIndicator = moduleIndicator
  },
}

export const actions = {
  async setModuleIndicator ({ commit }, payload) {
    commit(types.SET_MODULE_INDICATOR_START)

    commit(types.SET_MODULE_INDICATOR_SUCCESS, payload)
  },
}

// getters
export const getters = {
  moduleIndicator: state => state.moduleIndicator,
}
